import React, { useState, useEffect, useRef } from "react";
import { Text } from "./../Text/Text";
import { Icon } from "./../Icon/Icon";

export const PrototypeDropdown = ({
    questionArray,
    changeActiveQuestionProp,
    dropdownOpen,
    resultCount,
    test,
    taskSetting,
    onHeaderHeightChange
}) => {
    const wrapperRef = useRef(null);

    const [isListOpen, setListOpen] = useState(false);
    const [isActive, setActive] = useState(1);
    const changeActiveQuestion = (index) => {
        setActive(index);
    };
    const showPreQuestion = (type) => {
        if (type === "increase") {
            if (isActive !== 1) {
                changeActiveQuestion(isActive - 1, questionArray);
                changeActiveQuestionProp(isActive - 1);
            }
        } else {
            if (questionArray.length !== isActive) {
                changeActiveQuestion(isActive + 1, questionArray);
                changeActiveQuestionProp(isActive + 1);
            }
        }
    };

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setListOpen(false);
                    dropdownOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    useEffect(() => {
        changeActiveQuestion(1, questionArray);
    }, []);

    const headerRef = useRef(null);
    useEffect(() => {
        if (headerRef.current) {
            const height = headerRef.current.offsetHeight;
            if (onHeaderHeightChange) {
                onHeaderHeightChange(height);
            }
        }
    }, [isActive]);

    return (
        <div
            className="question-dropdown-container result-question-dropdown prototype-question-dropdown"
            ref={wrapperRef}
        >
            <div
                className="dropdown-header"
                onClick={(event) => {
                    if (
                        !event.target.classList.contains(
                            "dropdown-toggle-disabled"
                        )
                    ) {
                        if (questionArray.length > 1) {
                            setListOpen(!isListOpen);
                            dropdownOpen(!isListOpen);
                        }
                    }
                }}
                ref={headerRef}
            >
                <div className="dropdown-header-left">
                    <div className="dropdown-header-top">
                        <p className="text-small-info text-uppercase">
                            <span className="active-question">{isActive}</span>
                            <span className="text-lowercase">of</span>{" "}
                            {questionArray.length} -{" "}
                            {test.methodology === "First click"
                                ? "First click"
                                : "Prototype"}
                            <span className="questions-dropdown-result-count">
                                ({resultCount}{" "}
                                {resultCount > 1 ? " answers" : " answer"})
                            </span>
                        </p>
                    </div>
                    <div className="dropdown-header-bottom">
                        <div className="dropdown-header-selected-question">
                            <Text
                                type="body-text-1"
                                fontWeight="medium-font"
                                cssClasses={
                                    test.language == "ar" ? "arabic-font" : ""
                                }
                                dir="auto"
                            >
                                {questionArray &&
                                    questionArray.map((items, index) => {
                                        return (
                                            <React.Fragment key={items.id || `question-${index}`}>
                                                {isActive === index + 1 && (
                                                    <span>
                                                        {taskSetting ===
                                                            "closed"
                                                            ? "Task " +
                                                            (index + 1)
                                                            : "Flow " +
                                                            (index + 1)}

                                                        {items.description &&
                                                            " - " +
                                                            items.description}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                            </Text>
                        </div>
                        <div className="dropdown-header-arrow-buttons">
                            <div className="bd-que-slide-arrow">
                                <a
                                    onClick={() => {
                                        showPreQuestion("increase");
                                        if (isListOpen) {
                                            setListOpen(false);
                                            dropdownOpen(false);
                                        }
                                    }}
                                    className={`${isActive === 1 ? "disabled-link" : ""
                                        } dropdown-toggle-disabled`}
                                >
                                    <Icon
                                        value="back-arrow"
                                        size="medium"
                                        colorClass={
                                            "gray-50-svg dropdown-toggle-disabled"
                                        }
                                    />
                                </a>
                                <a
                                    onClick={() => {
                                        showPreQuestion("decrease");
                                        if (isListOpen) {
                                            setListOpen(false);
                                            dropdownOpen(false);
                                        }
                                    }}
                                    className={`${questionArray.length === isActive
                                        ? "disabled-link"
                                        : ""
                                        } dropdown-toggle-disabled`}
                                >
                                    <Icon
                                        value="forward-arrow"
                                        size="medium"
                                        colorClass={
                                            "gray-50-svg dropdown-toggle-disabled"
                                        }
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={`dropdown-header-right ${questionArray.length > 1 ? "" : "disabled-arrow"
                        }`}
                >
                    <div className="dropdown-header-chevron">
                        {isListOpen ? (
                            <Icon value="chevron-up" size="medium" />
                        ) : (
                            <Icon value="chevron" size="medium" />
                        )}
                    </div>
                </div>
            </div>

            <div className="dropdown-header-arrow-buttons none-for-desktop mobile-nav-arrows">
                <div className="bd-que-slide-arrow">
                    <a
                        onClick={() => {
                            showPreQuestion("increase");
                            if (isListOpen) {
                                setListOpen(false);
                                dropdownOpen(false);
                            }
                        }}
                        className={`${isActive === 1 ? "disabled-link" : ""
                            } dropdown-toggle-disabled`}
                    >
                        <Icon
                            value="back-arrow"
                            size="medium"
                            colorClass={"gray-50-svg dropdown-toggle-disabled"}
                        />
                    </a>
                    <a
                        onClick={() => {
                            showPreQuestion("decrease");
                            if (isListOpen) {
                                setListOpen(false);
                                dropdownOpen(false);
                            }
                        }}
                        className={`${questionArray.length === isActive
                            ? "disabled-link"
                            : ""
                            } dropdown-toggle-disabled`}
                    >
                        <Icon
                            value="forward-arrow"
                            size="medium"
                            colorClass={"gray-50-svg dropdown-toggle-disabled"}
                        />
                    </a>
                </div>
            </div>

            {isListOpen && (
                <div className="dropdown-list-hold-wrap">
                    <div className="dropdown-list-container">
                        {questionArray &&
                            questionArray.map((item, index) => (
                                <span
                                    className="dropdown-list-item"
                                    key={item.id}
                                    onClick={() => {
                                        setListOpen(false);
                                        dropdownOpen(false);
                                        changeActiveQuestion(
                                            index + 1,
                                            questionArray
                                        );
                                        changeActiveQuestionProp(index + 1);
                                    }}
                                >
                                    {isActive == index + 1 ? (
                                        <div className="dropdown-active-question dropdown-question-item flex-wrap">
                                            {test.language === "ar" ? (
                                                <>
                                                    <Text
                                                        type={"body-text-3"}
                                                        fontWeight={
                                                            "medium-font"
                                                        }
                                                        cssClasses={"mb-1"}
                                                    >
                                                        {taskSetting ===
                                                            "closed"
                                                            ? "Task " +
                                                            (index + 1)
                                                            : "Flow " +
                                                            (index + 1)}{" "}
                                                    </Text>
                                                </>
                                            ) : (
                                                <></>
                                            )}

                                            <Text
                                                type="body-text-1"
                                                fontWeight="medium-font"
                                                cssClasses={
                                                    test.language == "ar"
                                                        ? "arabic-font"
                                                        : ""
                                                }
                                            >
                                                <span className="none-for-arabic">
                                                    {taskSetting === "closed"
                                                        ? "Task " + (index + 1)
                                                        : "Flow " +
                                                        (index + 1)}{" "}
                                                    -
                                                </span>

                                                {item.description &&
                                                    item.description}
                                            </Text>
                                        </div>
                                    ) : (
                                        <div className="dropdown-question-item flex-wrap">
                                            {test.language === "ar" ? (
                                                <>
                                                    <Text
                                                        type={"body-text-3"}
                                                        fontWeight={
                                                            "medium-font"
                                                        }
                                                        cssClasses={"mb-1"}
                                                    >
                                                        {taskSetting ===
                                                            "closed"
                                                            ? "Task " +
                                                            (index + 1)
                                                            : "Flow " +
                                                            (index + 1)}{" "}
                                                    </Text>
                                                </>
                                            ) : (
                                                <></>
                                            )}

                                            <Text
                                                type="body-text-1"
                                                fontWeight="medium-font"
                                                cssClasses={
                                                    test.language == "ar"
                                                        ? "arabic-font"
                                                        : ""
                                                }
                                            >
                                                <span className="none-for-arabic">
                                                    {" "}
                                                    {taskSetting === "closed"
                                                        ? "Task " + (index + 1)
                                                        : "Flow " +
                                                        (index + 1)}{" "}
                                                    -
                                                </span>

                                                {item.description &&
                                                    item.description}
                                            </Text>
                                        </div>
                                    )}
                                </span>
                            ))}
                    </div>
                </div>
            )}
        </div>
    );
};
